@if (errorGenerico === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img src="/assets/img/error.png" width="70px" alt="">
      <h3 class="subtitulo-alert mt-3 mb-2">Ops. ocorreu um erro!</h3>
      <p class="paragrafo m-0">Ocorreu um erro ao tentar realizar a solicitação.<br>
      Verifique os dados e tente novamente.</p>
      <button class="botao-erro mt-4" (click)="fechar()">OK</button>
    </div>
  </div>
}